import { render, staticRenderFns } from "./BabyAgeDisplay.vue?vue&type=template&id=71f279d4"
import script from "./BabyAgeDisplay.vue?vue&type=script&lang=js"
export * from "./BabyAgeDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports